import Base from './action-base'
import renderFields from './flag.pug'

export default class Flag extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-flag"

  @DEFAULTS:
    names: []

  renderFields: renderFields

  onSave: (newData)->
    newData.names = newData.names.filter((s) => s.length)
